import { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isValidLang, DEFAULT_LANG, LANGS } from './seoConfig';

// Redirects "/" to the visitor's detected/stored language
export const PREF_KEY = 'preferredLng';

const detectLanguage = () => {
  const saved = (localStorage.getItem(PREF_KEY) || '').slice(0, 2);
  if (LANGS.includes(saved)) return saved;
  const browserLangs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
  for (const l of browserLangs) {
    const code = (l || '').slice(0, 2).toLowerCase();
    if (LANGS.includes(code)) return code;
  }
  return DEFAULT_LANG;
};

// Redirects "/" to the saved language, else the browser language (DE/FR/EN), else /de
export const RootRedirect = () => <Navigate to={`/${detectLanguage()}`} replace />;

// Keeps i18next in sync with the :lang URL segment
export const LangLayout = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const valid = isValidLang(lang);

  useEffect(() => {
    if (!valid) return;
    if (i18n.language !== lang) i18n.changeLanguage(lang);
    localStorage.setItem(PREF_KEY, lang);
  }, [lang, valid, i18n]);

  if (!valid) return <Navigate to="/404" replace />;
  return <Outlet />;
};
